// extracted by mini-css-extract-plugin
module.exports = {"img":"CarouselSection_img__HzNsS","color":"CarouselSection_color__D34E8"};